<template>
  <div>
    <div class="row mt-2">
      <div class="col">
        <TitleBreadcrumb :page="page" />
      </div>
      <div class="col">
        <div class="row">
          <div class="col-12">
            <div class="d-flex mt-5 justify-content-end">
              <router-link to="/pei/detail">
                <ActionButton
                  i="fas fa-arrow-circle-left"
                  variant="outline-success m-2"
                  name="btnRegresar"
                >
                  Regresar
                </ActionButton>
              </router-link>
              <ActionButton
                v-if="canShowUncompleteBtn"
                name="btnNoCompleted"
                i="fas fa-file-edit"
                variant="outline-success m-2"
                @click="setChecklistNoComplete"
              >
                No Completado
              </ActionButton>
              <ActionButton
                v-if="canShowCompleteBtn"
                name="btnCompleted"
                i="fas fa-flag"
                variant="outline-success m-2"
                @click="setChecklistComplete"
              >
                Completar
              </ActionButton>
              <ActionButton
                v-show="!isReadOnly"
                i="fas fa-save"
                variant="success m-2"
                name="btnSaveCollectionSheet"
                @click="btnSaveCollectionSheet"
              >
                Guardar
              </ActionButton>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="showAlertError"
      id="validation-message"
      class="alert alert-danger border border-danger"
      role="alert"
    >
      <i class="fal fa-exclamation-triangle" />
      <span class="text">Informaci&oacute;n Incompleta</span>
    </div>
    <div class="border-bottom" />
    <div class="panel-simple">
      <div class="header global-thead-dark">
        <div class="col">
          <span class="d-flex">Lista de Respuestas de Hoja de Cotejo</span>
        </div>
      </div>

      <div class="panel-row-without-selector text-left mt-2">
        <div
          v-for="(question, index) in questions"
          :key="question.number"
          class="container-fluid panel panel-primary"
        >
          <question
            id="qQuestions"
            :ref="'question_' + question.number"
            :default-option-value-selected="question.answerId"
            :number="question.number"
            :sub-number="question.subNumber"
            :description="question.description"
            :answer-control-type="question.answerControlType"
            :error-message="question.errorMessage"
            :warning-message="question.warningMessage"
            :on-change="question.onChange"
            :get-default-value="question.getDefaultValue"
            :option-list-value="question.optionListValue"
            :get-options="question.getOptions"
            :is-required="question.isRequired"
            :require-error-message="question.requireErrorMessage"
            :visible="question.isVisible"
            :display-number="String(index + 1)"
            :picker-min-date="question.pickerMinDate"
            :notes="question.notes"
            :fields="question.fields"
            :field-caption="question.fieldCaption"
            :show-field-caption="question.showFieldCaption"
            :column-offset="1"
            :is-disabled="isReadOnly"
            @replace-file="onReplaceFileHandler($event)"
          />
        </div>

        <div v-if="ShowQuestionAdditionalBlock" class="row ml-5 mt-4 mb-4">
          <Badge :i="subPage.icon" :title="subPage.title" />
        </div>

        <div v-if="ShowQuestionAdditionalBlock" class="mt-2">
          <div
            v-for="(question, index) in adiccionalQuestions"
            :key="question.number"
            class="container-fluid panel panel-primary"
          >
            <question
              id="qAdditionalQuestions"
              :ref="'question_' + question.number"
              :default-option-value-selected="question.answerId"
              :number="question.number"
              :sub-number="question.subNumber"
              :description="question.description"
              :answer-control-type="question.answerControlType"
              :error-message="question.errorMessage"
              :warning-message="question.warningMessage"
              :on-change="question.onChange"
              :get-default-value="question.getDefaultValue"
              :get-options="question.getOptions"
              :option-list-value="question.optionListValue"
              :is-required="question.isRequired"
              :require-error-message="question.requireErrorMessage"
              :visible="question.isVisible"
              :display-number="String(index + 1)"
              :picker-min-date="question.pickerMinDate"
              :notes="question.notes"
              :fields="question.fields"
              :field-caption="question.fieldCaption"
              :show-field-caption="question.showFieldCaption"
              :is-comment-mode="question.isCommentMode"
              :column-offset="1"
              :is-disabled="isReadOnly"
            />
          </div>
        </div>
      </div>

      <div
        v-show="showFooterBar"
        id="checklist-footer"
        class="footer-container fixed-bottom bg-white"
      >
        <div class="footer-menu">
          <div class="footer-row d-flex justify-content-end">
            <router-link to="/pei/detail">
              <ActionButton
                i="fas fa-arrow-circle-left"
                variant="outline-success m-2"
              >
                Regresar
              </ActionButton>
            </router-link>
            <ActionButton
              v-if="canShowUncompleteBtn"
              i="fas fa-file-edit"
              variant="outline-success m-2"
              @click="setChecklistNoComplete"
            >
              No Completado
            </ActionButton>
            <ActionButton
              v-if="canShowCompleteBtn"
              i="fas fa-flag"
              variant="outline-success m-2"
              @click="setChecklistComplete"
            >
              Completar
            </ActionButton>
            <ActionButton
              v-show="!isReadOnly"
              i="fas fa-save"
              variant="success m-2"
              @click="btnSaveCollectionSheet"
            >
              Guardar
            </ActionButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped src="@/assets/css/component/panel-simple.css"></style>

<script>
import store from '@/store/index';
import TitleBreadcrumb from '@/components/common/page/TitleBreadcrumb';
import Badge from '@/components/common/page/badge/Badge';
import ActionButton from '@/components/common/ActionButton';
import Question from './WizardQuestion';
import PeiStatus from '../../utils/constants/pei/peiStatus';
import PeiCheckListStatus from '../../utils/constants/pei/peiCheckListStatus';
import AlertMixin from '../../mixin/alert.mixin';
import LoadingMixin from '../../mixin/loading.mixin';
import EduEspYesNoNA from '@/utils/constants/EduEspYesNoNA';
import ValidationResultTypes from '../../utils/constants/pei/wizard/validationResultType';
import DateUtils from '../../utils/dateUtil';
import moment from 'moment';
import peiServices from '@/services/pei/general';
import fileInputStatus from '@/utils/constants/fileInputStatus';
import codeDocumentTypes from '@/utils/constants/documentTypes';
import thrpiesServiceCode from '@/utils/constants/thpiesService.js';
import academicYears from '@/utils/constants/academicYears';

export default {
  components: {
    Question,
    TitleBreadcrumb,
    Badge,
    ActionButton,
  },
  mixins: [AlertMixin, LoadingMixin],
  data() {
    return {
      checklistSheet: null,
      ShowQuestionAdditionalBlock: false,
      Age: store.getters.SelectedStudent.age,
      showAlertError: false,
      validationMessages: [],
      validationFields: {},
      studentAgeByAcademicYear: 0.0,
      page: {
        icon: 'fas fa-user-edit',
        title: 'PEI: Hoja de Cotejo',
        routes: ['Inicio', 'PEI', 'Hoja de Cotejo'],
      },
      subPage: {
        icon: 'fas fa-user-edit',
        title: 'Razones para revisar el PEI fuera del término establecido',
      },
      //TODO 1: Colocar aqui la lista de preguntas
      questions: [],
      adiccionalQuestions: [],
      questionFields: [
        {
          questionNumber: 2.854,
          fieldCaption: '<b>Documento de Rechazo de Ubicación</b>',
          showFieldCaption: true,
          fields: [
            {
              id: 'fecha',
              type: 'date',
              label: '<b>Fecha:</b>',
              name: 'fecha',
              class: 'col-lg-3 col-sm-6',
              value: null,
              required: true,
              requireErrorCode: '0737',
              requireErrorMessage: '',
              showWithValue: 146,
              maxDate: new Date(),
            },
            {
              id: 'attachment',
              attachmentId: null,
              attachmentStatus: null,
              name: 'attachment',
              type: 'file',
              label: '<b>Formulario de Rechazo:</b>',
              btnLabel: 'Descargar',
              class: 'col-lg-6 col-sm-6',
              value: null,
              required: true,
              requireErrorCode: '0738',
              requireErrorMessage: '',
              showWithValue: 146,
              canReplace: store.getters.HasPermission(
                'academic.pei.replacelocationrejecteddocument'
              ),
            },
          ],
        },
        {
          questionNumber: 2.855,
          onChange: this.onChangeQuestion2dot855,
        },
        {
          questionNumber: 2.859,
          fieldCaption:
            '<b>Certificación Tarea 15-Manual de EE para Madres y Padres</b>',
          showFieldCaption: true,
          fields: [
            {
              id: 'fechaCert',
              type: 'date',
              label: '<b>Fecha:</b>',
              name: 'fechaCert',
              class: 'col-lg-3 col-sm-6',
              value: null,
              required: true,
              requireErrorCode: '0737',
              requireErrorMessage: '',
              showWithValue: 146,
              maxDate: new Date(),
            },
            {
              id: 'attachmentCert',
              attachmentId: null,
              attachmentStatus: null,
              name: 'attachmentCert',
              type: 'file',
              label: '<b>Documento:</b>',
              btnLabel: 'Descargar',
              class: 'col-lg-6 col-sm-6',
              value: null,
              required: true,
              requireErrorCode: '0738',
              requireErrorMessage:
                'Favor de entregar al padre el Manual de Padres y subir la certificación requerida.',
              showWithValue: 146,
            },
          ],
        },
      ],
      pei: {},
      showFooterBar: false,
      prevScrollpos: window.pageYOffset,
      actualEligibilityDate: null,
    };
  },
  async mounted() {
    await this.getValidationFields();
    await this.loadQuestions();
    await this.getPei();
    await this.loadValidationMessages();
    await this.getStudentConfigGradeByAcademicYear();
    this.disableQuestions(this.isReadOnly);
  },
  watch: {
    isReadOnly(newValue) {
      this.disableQuestions(newValue);
    },
  },
  computed: {
    nameUser() {
      return (
        this.userProfile.firstname + ' ' + this.userProfile.lastpaternalname
      );
    },
    activeEducationalCompensatoryService() {
      return store.getters.activeEducationalCompensatoryService;
    },
    isY2024_2025() {
      return this.selectedPei.academicYearId >= academicYears.Y2024_2025;
    },
    peiId() {
      return this.$store.getters.SelectedPei;
    },
    selectedPei() {
      return this.$store.state.pei;
    },
    canShowCompleteBtn() {
      return (
        (this.pei.peiStatusCode == PeiStatus.Completado ||
          this.pei.peiStatusCode == PeiStatus.CompletedWithPendingFunds) &&
        (this.pei.checklistStatusCode == null ||
          this.pei.checklistStatusCode == PeiCheckListStatus.NoCompletado)
      );
    },
    canShowUncompleteBtn() {
      const completedStatuses = [
        PeiStatus.Completado,
        PeiStatus.CompletedWithPendingFunds,
      ];

      return (
        !this.canShowCompleteBtn &&
        completedStatuses.some((id) => id == this.pei.peiStatusCode) &&
        this.pei.checklistStatusCode != null &&
        this.pei.checklistStatusCode == PeiCheckListStatus.Completado &&
        this.hasEditPermission
      );
    },
    hasEditPermission() {
      return store.getters.HasPermission('pei.checklist.edit');
    },
    selectedStudent() {
      return store.getters.SelectedStudent;
    },
    isReadOnly() {
      return (
        this.pei.checklistStatusCode == PeiCheckListStatus.Completado ||
        this.isSignedPei
      );
    },
    canReplaceLocationRejectedDocument() {
      // Con el PEI firmado la Hoja de Cotejo es solo lectura: no se reemplazan documentos.
      return (
        !this.isSignedPei &&
        store.getters.HasPermission(
          'academic.pei.replacelocationrejecteddocument'
        )
      );
    },
    isSignedPei() {
      return (
        this.selectedPei.peiStatusCode == PeiStatus.SignedWithControversy ||
        this.selectedPei.peiStatusCode == PeiStatus.PartialSignedPendingFunds ||
        this.selectedPei.peiStatusCode == PeiStatus.Firmado
      );
    },
  },
  methods: {
    onQuestion17ValueChange(question) {
      let questionElement = this.getQuestion(question.number);

      if (question.selectedAnswer === EduEspYesNoNA.No) {
        let attachmentField = questionElement.getFieldElement('attachment');

        if (attachmentField.attachmentId != null) {
          attachmentField.status = fileInputStatus.Deleted;
        }
        questionElement.isVisibleFieldCaption = false;
      } else {
        questionElement.isVisibleFieldCaption = true;
      }
    },
    onQuestion25ValueChange(question) {
      let questionElement = this.getQuestion(question.number);

      if (question.selectedAnswer === EduEspYesNoNA.No) {
        let attachmentField = questionElement.getFieldElement('attachmentCert');

        if (attachmentField.attachmentId != null) {
          attachmentField.status = fileInputStatus.Deleted;
        }
        questionElement.isVisibleFieldCaption = false;
      } else {
        questionElement.isVisibleFieldCaption = true;
      }
    },
    onQuestion16ValueChange(question) {
      let nextQuestion = this.getQuestion(2.854);
      if (
        question.selectedAnswer != undefined &&
        question.selectedAnswer === EduEspYesNoNA.No
      ) {
        nextQuestion.isVisible = true;
        nextQuestion.isRequired = true;
      } else {
        nextQuestion.isVisible = false;
        nextQuestion.isRequired = false;
      }
    },
    getNoteFromArrayMessege(listMessege) {
      let listMsg = [];
      listMessege.forEach((msg) => {
        listMsg.push({ message: msg });
      });
      return listMsg;
    },
    setListQuestionsToSendApi(
      listQuestionToIterate,
      listQuestiosnToSaveAndSend
    ) {
      listQuestionToIterate.forEach((question) => {
        let number = parseFloat(question.number);
        let questionFromComponentWithValue = this.getQuestion(number);
        if (questionFromComponentWithValue != null) {
          listQuestiosnToSaveAndSend.push({
            PeiId: this.$store.state.peiSelected,
            QuestionId: question.questionId,
            AnswerId: questionFromComponentWithValue.selectedAnswer
              ? questionFromComponentWithValue.selectedAnswer
              : 0,
            Comment:
              questionFromComponentWithValue.questionFields.length > 0
                ? questionFromComponentWithValue.questionFields[0].value
                : '',
          });
        }
      });

      return listQuestiosnToSaveAndSend;
    },
    getQuestionDetail(questionNumber) {
      let question = this.questionFields.find(
        (q) => q.questionNumber == questionNumber
      );
      if (question != null) {
        return question;
      }
      return null;
    },
    getItemFromOptionsRadios(item) {
      return item.Display === 'No';
    },
    async loadQuestions() {
      let result = await this.$ApiGet(
        '/api/pei/getquestioncollectionsheet?peiId=' +
          this.$store.getters.SelectedPei
      );
      this.checklistSheet = result.data;
      let checklistSheet = result.data;

      let nameUser = this.nameUser;
      let self = this;
      let questionlist = [];
      let questionAdditionalList = [];
      let showQuestion17 = false;

      checklistSheet.questions.forEach(function(question) {
        let questionFields = [];
        let optionsRadios = self.getOption(question.answerList);

        if (
          question.reasonFlag &&
          (optionsRadios.length > 1 || question.questionId == 861)
        ) {
          questionFields = self.getCommentField(
            question.answersThatShowComment,
            question.comment
          );
        }

        let qt = {
          answerId: question.answerId,
          questionId: question.questionId,
          displayNumber: question.questionSort,
          number: parseFloat(question.categoryId + '.' + question.questionId), //25,
          description: question.question, //"No se proveyó cita dentro del período establecido.",
          optionListValue: optionsRadios,
          answerControlType: 8,
          isRequired: true,
          requireErrorCode: '',
          requireErrorMessage: 'El campo es requerido.',
          initialState: true,
          fieldCaption: '',
          showFieldCaption: true,
          fields: questionFields,
          notes:
            question.toolTipText != null && question.toolTipText != undefined
              ? self.getNoteFromArrayMessege(question.toolTipText.split('|'))
              : null,
        };

        if (question.questionId == 835) {
          qt.onChange = self.onQuestion16ValueChange;
          showQuestion17 = qt.answerId === EduEspYesNoNA.No;
        }

        if (question.questionId == 854) {
          qt.isVisible = showQuestion17;
          qt.onChange = self.onQuestion17ValueChange;

          if (qt.answerId === EduEspYesNoNA.No) {
            qt.showFieldCaption = false;
          } else {
            qt.showFieldCaption = true;
          }
        }
        if (question.questionId == 859) {
          qt.isVisible = true;
          qt.onChange = self.onQuestion25ValueChange;

          if (qt.answerId === EduEspYesNoNA.No) {
            qt.showFieldCaption = false;
          } else {
            qt.showFieldCaption = true;
          }
        }
        if (question.questionId == 861) {
          qt.answerId = 146;
          qt.showFieldCaption = false;
        }
        //Agregando campos adicionales.
        let questionDetail = self.getQuestionDetail(qt.number);
        if (questionDetail != null) {
          if (
            questionDetail.fields != null &&
            questionDetail.fields.length > 0
          ) {
            qt.fields = qt.fields.concat(questionDetail.fields);

            if (questionDetail.fieldCaption != null) {
              qt.fieldCaption = questionDetail.fieldCaption;
            }

            let hasToShowQuestion17Fields =
              showQuestion17 && question.questionId == 854;

            if (hasToShowQuestion17Fields) {
              const dateField = qt.fields.find((a) => a.id == 'fecha');

              if (checklistSheet.locationRejectedDocument) {
                let documentDate =
                  checklistSheet.locationRejectedDocument.documentDate;
                dateField.value = new Date(documentDate);

                const documentField = qt.fields.find(
                  (f) => f.id == 'attachment'
                );

                documentField.attachmentId =
                  checklistSheet.locationRejectedDocument.itemAttachmentId;
                documentField.attachmentStatus = fileInputStatus.Loaded;
                documentField.name = 'Formulario Rechazo Ubicacion.pdf';
                documentField.canReplace =
                  self.canReplaceLocationRejectedDocument;
              }
            }

            let hasToShowQuestion25Fields = question.questionId === 859;

            if (hasToShowQuestion25Fields) {
              const dateField = qt.fields.find((a) => a.id == 'fechaCert');

              if (checklistSheet.certTarea15EEDocument) {
                let documentDate =
                  checklistSheet.certTarea15EEDocument.documentDate;
                dateField.value = new Date(documentDate);

                const documentField = qt.fields.find(
                  (f) => f.id == 'attachmentCert'
                );

                documentField.attachmentId =
                  checklistSheet.certTarea15EEDocument.itemAttachmentId;
                documentField.attachmentStatus = fileInputStatus.Loaded;
                documentField.name =
                  'Certificación Tarea 15-Manual de EE para Madres y Padres.pdf';
              }
            }
          }
          if (questionDetail.onChange != null) {
            qt.onChange = questionDetail.onChange;
          }
        }

        if (question.questionId == 157) {
          qt.description = question.question.replace('{0}', nameUser);
        }

        if (question.categoryId < 3) {
          questionlist.push(qt);
        } else {
          questionAdditionalList.push(qt);
        }
      });
      this.actualEligibilityDate = checklistSheet.actualEligibilityDate;
      this.questions = questionlist;
      this.adiccionalQuestions = questionAdditionalList;

      this.ShowQuestionAdditionalBlock = this.adiccionalQuestions.length > 0;
    },
    getCommentField(valuesForShowComment, valueComment) {
      return [
        {
          id: 'comentario',
          type: 'textarea',
          label: '<b>Comentario:</b>',
          name: 'question-comment',
          class: 'col-lg-12 col-sm-6',
          maxChars: 500,
          value: valueComment,
          required: true,
          requireErrorCode: '',
          requireErrorMessage: 'Por favor introduzca texto',
          showWithValue:
            valuesForShowComment != null && valuesForShowComment.length > 0
              ? valuesForShowComment[0]
              : 0,
          listValuesForShow: valuesForShowComment,
          showFieldValidation: true,
        },
      ];
    },
    getOption(options) {
      let listOptions = [];
      options.forEach(function(question) {
        listOptions.push({
          Display: question.checkListAnswer,
          Value: question.checkListAnswerId,
        });
      });
      return listOptions;
    },

    validateCollectionSheet() {
      let isValidChecklistQuestions = true;
      let onCompleteQuestionValidations = [];

      this.questions.forEach((question) => {
        let questionElement = this.getQuestion(question.number);

        //pregunta 2: validación agencias
        if (questionElement.number == 1.295) {
          let question2Result = this.question2Validator();
          onCompleteQuestionValidations.push(question2Result);
        }

        //pegunta 8: validación 14 años
        if (questionElement.number == 1.296) {
          let question8Result = this.question8Validator();
          onCompleteQuestionValidations.push(question8Result);
        }

        //pregunta 10: validación pregunta servicios suplementarios
        if (questionElement.number == 1.833) {
          let question10Result = this.question10Validator();
          onCompleteQuestionValidations.push(question10Result);
        }

        //pregunta 11: validación pregunta asistenia tecnológica
        if (questionElement.number == 1.834) {
          let question11Result = this.question11Validator();
          onCompleteQuestionValidations.push(question11Result);
        }

        //pregunta 12: validación pregunta servicios relacionados
        if (questionElement.number == 2.832) {
          let question12Result = this.question12Validator();
          onCompleteQuestionValidations.push(question12Result);
        }

        //pregunta 17: validación pregunta servicios relacionados
        if (questionElement.number == 2.854) {
          let question17Result = this.question17Validator();
          onCompleteQuestionValidations.push(question17Result);
        }

        // pregunta 25: validación pregunta certificación tarea 15-Manual de EE para Madres y Padres
        if (questionElement.number == 2.859) {
          let question25Result = this.question25Validator();
          onCompleteQuestionValidations.push(question25Result);
        }

        if (!questionElement.validate()) {
          isValidChecklistQuestions = false;
        }
      });

      let isValidQuestionAditional = true;

      if (
        this.adiccionalQuestions != null &&
        this.adiccionalQuestions.length > 0
      ) {
        this.adiccionalQuestions.forEach((questionAdit) => {
          let questionAditional = this.getQuestion(questionAdit.number);
          if (questionAditional != null && !questionAditional.validate()) {
            isValidQuestionAditional = false;
          }
        });
      }

      let isValid =
        isValidChecklistQuestions &&
        !onCompleteQuestionValidations.some((element) => !element) &&
        isValidQuestionAditional;

      if (!isValid) {
        this.ShowToast('Alerta', 'Información Incompleta', 'error');
      }

      return isValid;
    },
    async btnSaveCollectionSheet() {
      let result = await this.saveChanges();
      if (!result) {
        await this.ShowToast(
          'Error',
          'Ha ocurrido un error inesperado.',
          'error'
        );
      }
      await this.ShowToast(
        '',
        'Los datos fueron guardados exitosamente.',
        'success'
      );
    },
    async saveChanges() {
      let listQuestionsAnswer = [];
      this.setListQuestionsToSendApi(this.questions, listQuestionsAnswer);
      this.setListQuestionsToSendApi(
        this.adiccionalQuestions,
        listQuestionsAnswer
      );
      let result = await this.$ApiPost(
        `/api/pei/savequestioncollectionsheet`,
        listQuestionsAnswer
      );

      if (result.status == 200) {
        // question 17: rechazo de ubicacion
        await this.uploadDocumentForQuestionNumber(
          2.854,
          codeDocumentTypes.LocationRejectedDocument
        );
        // question 25: certificacion tarea 15
        await this.uploadDocumentForQuestionNumber(
          2.859,
          codeDocumentTypes.CertTarea15ManualEEMadrePadre
        );

        return true;
      }
      return false;
    },
    async uploadDocumentForQuestionNumber(questionNumber, documentType) {
      let questionElement = this.getQuestion(questionNumber);

      if (questionElement != null) {
        let date =
          documentType == codeDocumentTypes.LocationRejectedDocument
            ? questionElement.getField('fecha')
            : questionElement.getField('fechaCert');

        let dateValue = date.value;

        let documentField =
          documentType == codeDocumentTypes.LocationRejectedDocument
            ? questionElement.getFieldElement('attachment')
            : questionElement.getField('attachmentCert');

        if (
          date != null &&
          documentField != null &&
          documentField.value != null
        ) {
          let date = dateValue ? moment(dateValue).toISOString() : null;

          let document = {
            id: this.peiId,
            date: date,
            file: documentField.value,
            attachmentId: documentField.attachmentId,
            status: fileInputStatus.Loaded,
            documentType: documentType,
          };

          await peiServices.uploadDocument(document);
        }
      }
    },
    getQuestion(number) {
      if (this.$refs['question_' + number] != null)
        return this.$refs['question_' + number][0];
      return null;
    },
    onRegionChange(item, question) {
      if (item) {
        //Example: Optener elemento de pregunta.
        let questionElement = this.getQuestion(question.number);

        //Example: Obteniendo campo en especifico(modelo) para actualizar opciones.
        let field = questionElement.getField('distrito');
        field.options = [
          {
            id: 'txtDropDown1',
            label: 'Drop Down',
          },
          {
            id: 'txtDropDown2',
            label: 'Drop Down 2',
          },
          {
            id: 'txtDropDown3',
            label: 'Drop Down 3',
          },
        ];
      }
    },
    getValidationMessage(code) {
      let result = this.validationMessages.find((item) => item.id === code);
      return result.name;
    },
    async loadValidationMessages() {
      let self = this;
      const messageCodes = [
        '2',
        '3',
        '4',
        'R03200049',
        'R03200050',
        '190604',
        '190605',
        '190608',
        '190609',
        '190725',
        '190722',
        '190724',
        '190723',
        '22061',
        '190902',
        '190606',
        '190607',
        '15',
        '17',
        '19',
        '22063',
        '22064',
        '22067',
        '22068',
        '22075',
        '22076',
        '22065',
        '22066',
        '23010',
        '0737',
        '0738',
        '9010',
      ];

      let result = await self.$ApiGet(
        '/api/validationsmessages?messageCodes=' +
          messageCodes.join('&messageCodes=')
      );
      self.validationMessages = result.data;
      self.questions.forEach((question) => {
        if (
          question.requireErrorCode != '' &&
          question.requireErrorCode != null &&
          question.requireErrorCode != undefined
        ) {
          question.requireErrorMessage = self.getValidationMessage(
            question.requireErrorCode
          );
        }
        if (question.fields != null) {
          question.fields.forEach((item) => {
            let questionElement = self.getQuestion(question.number);
            if (questionElement) {
              let field = questionElement.getField(item.id);
              if (
                field.requireErrorCode != '' &&
                field.requireErrorCode != null &&
                field.requireErrorCode != undefined
              ) {
                field.requireErrorMessage = self.getValidationMessage(
                  field.requireErrorCode
                );
              }
            }
          });
        }
      });
    },
    question10Validator() {
      let question10 = this.getQuestion(1.833);
      question10.invalidSelection = false;
      return true;
    },
    async getPei() {
      let self = this;
      self
        .$ApiGet('/api/pei/getpei?peiId=' + self.peiId)
        .then((res) => {
          self.pei = res.data;

          //set technical assistance question
          self.setQuestion11();
          //set related services needs question
          self.setQuestion12();
        })
        .catch((err) => {
          self.response = err;
        });
    },
    setQuestion11() {
      let question11 = this.getQuestion(1.834);
      question11.disabled = true;
      question11.answerControlType = 1;
      question11.selectedAnswer = EduEspYesNoNA.Yes;
      if (this.pei != null && this.pei.otherServTechAssistEquipFlag == '0') {
        question11.answerControlType = 1;
        question11.selectedAnswer = EduEspYesNoNA.NA;
        question11.disabled = true;
      }
    },
    setQuestion12() {
      let question12 = this.getQuestion(1.833);
      if (this.pei != null && this.pei.unilateralFlag == '1') {
        question12.selectedAnswer = EduEspYesNoNA.NA;
        question12.disabled = true;
      } else {
        question12.disabled = false;
      }
    },
    disableQuestions(isDisabled) {
      this.questions.forEach((q) => {
        let question = this.getQuestion(q.number);
        if (question != null) {
          question.disabled = isDisabled;
        }
      });

      this.adiccionalQuestions.forEach((aq) => {
        let adiccionalQuestion = this.getQuestion(aq.number);
        if (adiccionalQuestion != null) {
          adiccionalQuestion.disabled = isDisabled;
        }
      });
    },
    question11Validator() {
      let question11 = this.getQuestion(1.834);
      question11.invalidSelection = false;
      return true;
    },
    question17Validator() {
      let question17 = this.getQuestion(2.835);
      let question18 = this.getQuestion(2.854);

      if (
        question17.selectedAnswer == EduEspYesNoNA.No &&
        question18.selectedAnswer == EduEspYesNoNA.No
      ) {
        question17.invalidSelection = true;
        question17.validationResult.messageText = this.getValidationMessage(
          '9010'
        );

        return false;
      }

      if (
        question17.selectedAnswer == EduEspYesNoNA.No &&
        question18.selectedAnswer == EduEspYesNoNA.Yes &&
        this.studentAgeByAcademicYear < 6.0
      ) {
        question17.invalidSelection = true;
        question17.validationResult.messageText =
          'Se identificó que el estudiante aún se encuentra en edad pre-escolar por lo que se debe identificar bajo Centro de Cuido en la pregunta 5.1 del Define PEI.';

        return false;
      }

      question17.invalidSelection = false;

      return true;
    },
    question25Validator() {
      let question25 = this.getQuestion(2.859);
      question25.invalidSelection = false;

      return true;
    },
    question12Validator() {
      let question12 = this.getQuestion(2.832);
      let serviciosRelacionados = this.validationFields.hasValidRelatedServices;
      if (
        question12.selectedAnswer == EduEspYesNoNA.Yes &&
        !serviciosRelacionados
      ) {
        question12.invalidSelection = true;
        question12.validationResult.messageText = this.getValidationMessage(
          '22065'
        );
        return false;
      } else if (
        question12.selectedAnswer == EduEspYesNoNA.NA &&
        serviciosRelacionados
      ) {
        question12.invalidSelection = true;
        question12.validationResult.messageText = this.getValidationMessage(
          '22066'
        );
        return false;
      } else {
        question12.invalidSelection = false;
        return true;
      }
    },
    question2Validator() {
      let question2 = this.getQuestion(1.295);
      let documentacionAgencia = this.validationFields.hasValidAgencies;

      if (
        question2.selectedAnswer == EduEspYesNoNA.Yes &&
        !documentacionAgencia
      ) {
        question2.invalidSelection = true;
        question2.validationResult.messageText = this.getValidationMessage(
          '22063'
        );
        return false;
      } else if (
        question2.selectedAnswer == EduEspYesNoNA.No &&
        documentacionAgencia
      ) {
        question2.invalidSelection = true;
        question2.validationResult.messageText = this.getValidationMessage(
          '22064'
        );
        return false;
      } else if (!question2.selectedAnswer) {
        question2.invalidSelection = true;
        question2.validationResult.messageText = 'El campo es requerido.';
        return false;
      } else {
        question2.invalidSelection = false;
        return true;
      }
    },
    question8Validator() {
      let question8 = this.getQuestion(1.296);

      if (question8.selectedAnswer == EduEspYesNoNA.No) {
        question8.invalidSelection = false;
        return true;
      } else if (
        question8.selectedAnswer == EduEspYesNoNA.Yes &&
        this.Age < 14
      ) {
        question8.invalidSelection = true;
        question8.validationResult.messageText = this.getValidationMessage(
          '23010'
        );
        return false;
      }

      return true;
    },
    async getValidationFields() {
      let self = this;
      await self
        .$ApiGet('/api/pei/verifyfields?peiId=' + self.peiId)
        .then((res) => {
          self.validationFields = res.data;
        })
        .catch((err) => {
          self.response = err;
        });
    },
    handleScroll() {
      let currentScrollPos = window.pageYOffset;
      this.showFooterBar = 300 <= currentScrollPos;
      this.prevScrollpos = currentScrollPos;
    },
    async changeChecklistStatus(changeStatusRequest) {
      return await this.$ApiPost(
        '/api/pei/changecheckliststatus',
        changeStatusRequest
      );
    },
    async isCompensatoryServicesInvalid() {
      const res = await this.$ApiGet(
        `/api/pei/validateCompensatoryServices/${this.peiId}/${store.getters.SelectedStudent.studentId}`
      );
      const { data: peiQuantity } = await peiServices.getPeiQuantity(
        Number(store.getters.SelectedStudent.studentId)
      );
      if (this.activeEducationalCompensatoryService) {
        let errors = [];

        const hasEducationalError = res.data.some(
          (x) => x.diciplineTypeId === thrpiesServiceCode.Educativo
        );

        if (hasEducationalError) {
          errors.push({
            name: null,
            sortOrder: 0,
            isDirty: false,
            id: 'EducationalCompensationCurrentServiceUnanswered',
            value: null,
            keyId: null,
          });
        }

        res.data
          .filter((x) => x.diciplineTypeId !== thrpiesServiceCode.Educativo)
          .forEach((element) => {
            errors.push({
              name: element.diciplineTypeId,
              sortOrder: 0,
              isDirty: false,
              id: `CompensationServiceInvalid-${element.programServiceAreaId}`,
              value: null,
              keyId: null,
            });
          });

        if (errors.length > 0 && peiQuantity > 1) {
          const tab11Validation = {
            errors: errors,
            name: 'Tab11',
            sortOrder: 0,
            isDirty: false,
            id: 'Tab11',
            value: true,
            keyId: null,
          };

          const validations = {
            validation: [tab11Validation],
            tabValidation: [tab11Validation],
          };

          store.dispatch('setPeiValidationTriggered', validations);

          return true;
        }
      }

      store.commit('setCompensatoryServices', res.data);
      const listCompensate = store.state.compensatoryServicesValidation;
      let hasTherapy = false;
      if (listCompensate.length > 0 && this.isY2024_2025) {
        hasTherapy = listCompensate.some((objeto) =>
          Object.values(thrpiesServiceCode).includes(objeto.diciplineTypeId)
        );
      }

      return peiQuantity > 1 && hasTherapy === true;
    },
    async isResultSummaryInvalid() {
      const { data: response } = await this.$ApiGet(
        `/api/pei/validateresultsummary/${this.peiId}`
      );
      store.commit('setResultSummaryValidation', response);
      let isInvalid = false;
      if (response?.programServiceAreaIds?.length > 0) {
        isInvalid = true;
      }

      return isInvalid;
    },
    async setChecklistComplete() {
      if (await this.isResultSummaryInvalid()) {
        this.ShowToast(
          'Error',
          'Se identifico que no ha completado el Resumen de Resultados, debe regresar el PEI a Borrador y completar la información.',
          'error'
        );

        return;
      }
      // check if compensatory service has therapy without completion
      if (await this.isCompensatoryServicesInvalid()) {
        this.ShowToast(
          'Error',
          'Se identifico que no ha completado el plan de compensación de servicios, debe regresar el PEI a Borrador y completar la información.',
          'error'
        );

        return;
      }

      if (this.validateCollectionSheet()) {
        let canContinue = true;
        let needConfirmation = false;
        let question17 = this.getQuestion(2.835);
        let questionIsUnilateral = this.getQuestion(2.854);

        if (
          question17 != null &&
          question17.selectedAnswer === EduEspYesNoNA.No &&
          questionIsUnilateral != null
        ) {
          needConfirmation =
            questionIsUnilateral.selectedAnswer === EduEspYesNoNA.Yes;
          if (needConfirmation) {
            canContinue = await this.ShowCancelModal(
              'Confirmacion',
              '¿Estás seguro que desea continuar con el rechazo de la propuesta de PEI?',
              'Si',
              'No'
            );
          }
        }

        if (canContinue && (await this.saveChanges())) {
          let closeDate = needConfirmation
            ? questionIsUnilateral.getField('fecha').value
            : null;

          let changeStatusRequest = {
            peiNum: this.peiId,
            statusId: PeiCheckListStatus.Completado,
            isProposalRejected: needConfirmation,
            closeDate: closeDate,
          };
          await this.changeChecklistStatus(changeStatusRequest);
          await this.getPei();

          this.disableQuestions(true);

          this.ShowToast('', 'Estatus cambiado a completado', 'success');
        }
      }
    },
    async setChecklistNoComplete() {
      let changeStatusRequest = {
        peiNum: this.peiId,
        statusId: PeiCheckListStatus.NoCompletado,
        isProposalRejected: false,
      };

      await this.changeChecklistStatus(changeStatusRequest);
      await this.getPei();

      this.ShowToast('', 'Estatus cambiado a no completado', 'success');
    },
    onChangeQuestion2dot855(question) {
      if (question.selectedAnswer === EduEspYesNoNA.Yes) {
        let today = new Date();

        let years = DateUtils.dayDiff(
          new Date(this.actualEligibilityDate),
          today
        );

        if (years > 3) {
          question.validationResult.messageText =
            'Debe cotejar la fecha de la determinación de elegibilidad.';
          question.validationResult.resultType = ValidationResultTypes.Warning;
          question.invalidSelection = true;
        }
      } else {
        question.invalidSelection = false;
        question.validationResult.resultType = ValidationResultTypes.Good;
      }
    },
    async getStudentConfigGradeByAcademicYear() {
      let { data } = await this.$ApiGet(
        '/api/student/getstudentageinacademicyear',
        {
          studentSie: this.$store.getters.SelectedStudent.studentId,
          academicYearId: this.$store.state.pei.academicYearId,
        }
      );
      this.studentAgeByAcademicYear = parseFloat(data);
    },
    async onReplaceFileHandler(data) {
      if (data.questionNumber == 2.854) {
        const formData = new FormData();
        formData.append('file', data.file);
        await peiServices.replaceLocationRejectedDocument(this.peiId, formData);
        await this.ShowToast(
          '',
          'El archivo fue reemplazado exitosamente.',
          'success'
        );
        await this.loadQuestions();
      }
    },
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style scoped>
#divCollationSheet {
  height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}
.panel-simple .header {
  box-shadow: 0px 15px 15px 0px #00000029;
}
.text-left {
  text-align: left;
}
.panel-row-without-selector {
  flex-direction: column;
}
.header-buttons .btn {
  height: 38px;
  text-align: center;
  font: Regular 16px/19px Lato;
}
#validation-message {
  border: 1px solid #ffebeb;
  background: #ffebeb 0% 0% no-repeat padding-box;
  border-radius: 4px;
  font-weight: normal;
  text-align: left;
  font: Regular 16px/24px Lato;
  letter-spacing: 0;
  color: #ff5b5c;
  opacity: 1;
}

#validation-message .text {
  padding-left: 10px;
}
</style>
